import { render } from "./mute-pill.vue?vue&type=template&id=1b34a878"
import script from "./mute-pill.vue?vue&type=script&lang=js"
export * from "./mute-pill.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__